/**
 * Tab Session Token Module - Manages a session token used for logging deduplication.
 * Format: <from>_<uuid> where 'from' is extracted from the URL and uuid is a unique identifier.
 * The token should be refreshed when user enters Career Scout (tab click, navigation, deep link).
 */

import { generateUUID } from "../../shared/util/generateUUID";

let tabSessionToken: string | undefined;

const DEFAULT_FROM = "career_scout_chat";

const extractFromParam = (url?: string | null): string => {
  if (!url) {
    return DEFAULT_FROM;
  }
  try {
    const urlObj = new URL(url, "https://www.indeed.com");
    return urlObj.searchParams.get("from") ?? DEFAULT_FROM;
  } catch {
    return DEFAULT_FROM;
  }
};

export const getTabSessionTk = (): string => {
  if (!tabSessionToken) {
    tabSessionToken = `${DEFAULT_FROM}_${generateUUID()}`;
  }
  return tabSessionToken;
};

export const refreshTabSessionTk = (url?: string | null, from?: string): string => {
  const fromParam = from ?? extractFromParam(url);
  tabSessionToken = `${fromParam}_${generateUUID()}`;
  return tabSessionToken;
};

export const clearTabSessionTk = (): void => {
  tabSessionToken = undefined;
};
